// src/pages/CaddyAcademy/CaddyAcademy.js
import React, { useRef, useLayoutEffect, useState } from 'react'
import styles from './CaddyAcademy.module.scss'
import { MainHeader } from '../../layout/Header/MainHeader'
import { MainFooter } from '../../layout/MainFooter'

const faqs = [
	{
		question: '자격 요건이 있나요?',
		answer: `1. 연령: 25세 이상
	2. 학력: 고등학교 졸업 이상 또는 이와 동등한 학력 소지자
	3. 필수조건: 병역 필 또는 군 면제자, 해외 여행에 결격 사유가 없는자
	4. 우대조건: 골프 관련 학과 재학생 또는 졸업생, 골프관련 자격증 소지자, 하우스 캐디 경력자, 자차 보유자`,
	},
	{
		question: '캐디 경력이 없는데 지원이 가능한가요?',
		answer: `1. 연령: 25세 이상
	2. 학력: 고등학교 졸업 이상 또는 이와 동등한 학력 소지자
	3. 필수조건: 병역 필 또는 군 면제자, 해외 여행에 결격 사유가 없는자
	4. 우대조건: 골프 관련 학과 재학생 또는 졸업생, 골프관련 자격증 소지자, 하우스 캐디 경력자, 자차 보유자`,
	},
	{
		question: '교육 일정은 어떻게 되나요?',
		answer: `1. 연령: 25세 이상
	2. 학력: 고등학교 졸업 이상 또는 이와 동등한 학력 소지자
	3. 필수조건: 병역 필 또는 군 면제자, 해외 여행에 결격 사유가 없는자
	4. 우대조건: 골프 관련 학과 재학생 또는 졸업생, 골프관련 자격증 소지자, 하우스 캐디 경력자, 자차 보유자`,
	},
	{
		question: '아카데미 종료 후 수료증을 받을 수 있나요?',
		answer: `1. 연령: 25세 이상
	2. 학력: 고등학교 졸업 이상 또는 이와 동등한 학력 소지자
	3. 필수조건: 병역 필 또는 군 면제자, 해외 여행에 결격 사유가 없는자
	4. 우대조건: 골프 관련 학과 재학생 또는 졸업생, 골프관련 자격증 소지자, 하우스 캐디 경력자, 자차 보유자`,
	},
]
const MyIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="currentColor"
		className={styles.featureIcon}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3 2.25a.75.75 0 0 1 .75.75v.54l1.838-.46a9.75 9.75 0 0 1 
         6.725.738l.108.054A8.25 8.25 0 0 0 18 4.524l3.11-.732a.75.75 0 
         0 1 .917.81 47.784 47.784 0 0 0 .005 10.337.75.75 0 0 1-.574.812l
         -3.114.733a9.75 9.75 0 0 1-6.594-.77l-.108-.054a8.25 8.25 0 0 0
         -5.69-.625l-2.202.55V21a.75.75 0 0 1-1.5 0V3A.75.75 0 0 1 3 2.25Z"
		/>
	</svg>
)

const CaddyAcademy = () => {
	// 박스 텍스트 데이터
	const boxData = [
		{ title: '투어 프로토콜 심화', subtitle: 'KPGA·KLPGA 공식 투어 규정과 매너를 체계적 숙지' },
		{
			title: '프로페셔널리즘 및 멘탈 전략',
			subtitle: '최상위 선수의 퍼포먼스를 극대화하는 파트너십 구축과 멘탈 케어 스킬을 학습',
		},
		{
			title: '투어 코스 공략 실습',
			subtitle: '실제 투어 개최 코스를 기준으로 야디지북 분석과 현장 공략 훈련',
		},
		{
			title: '코스 매니지먼트 전략',
			subtitle: '코스 설계 의도를 읽어 내고, 상황별 전략적 공략법을 설계',
		},
		{
			title: '실전형 라운드',
			subtitle:
				'투어 현장의 긴장감 속에서 라운드를 진행하며 실전 전략 수행과 즉각 피드백을 반복 훈련',
		},
		{
			title: '변수 통제 및 위기 관리',
			subtitle:
				'기상, 코스 컨디션 등 돌발 변수를 시뮬레이션하고 각 상황에 대한 대응 전략을 체득',
		},
	]

	// refs & state
	const featuresRef = useRef(null)
	const pathRef = useRef(null)
	const boxRefs = useRef([])
	const [pathLength, setPathLength] = useState(0)
	const [dotPositions, setDotPositions] = useState([])
	const [showDots, setShowDots] = useState([true, false, false])

	// → 화면 리사이즈 때마다 dot/line 위치 재계산
	const recalculate = () => {
		const container = featuresRef.current
		const path = pathRef.current
		if (!container || !path) return

		const contRect = container.getBoundingClientRect()
		const GAP = 30

		const firstRect = boxRefs.current[0].getBoundingClientRect()
		const thirdRect = boxRefs.current[2].getBoundingClientRect()
		const fourthRect = boxRefs.current[3].getBoundingClientRect()
		const lastRect = boxRefs.current[5].getBoundingClientRect()

		// X 위치
		const left1 = firstRect.left - contRect.left - GAP
		const left2 = thirdRect.left - contRect.left - GAP
		const left3 = lastRect.left - contRect.left - GAP

		// Y 위치: 각 박스 수직 중앙
		const top1 = Math.round(firstRect.top - contRect.top)
		const top2 = Math.round((thirdRect.bottom + fourthRect.top) / 2 - contRect.top)
		const top3 = Math.round(lastRect.bottom - contRect.top)

		const positions = [
			{ left: left1, top: top1 },
			{ left: left2, top: top2 },
			{ left: left3, top: top3 },
		]
		setDotPositions(positions)

		// path d 도 다시 설정
		const d = positions.map((p, i) => `${i === 0 ? 'M' : 'L'}${p.left},${p.top}`).join(' ')
		path.setAttribute('d', d)

		// strokeDasharray
		const length = path.getTotalLength()
		path.style.strokeDasharray = length
	}

	useLayoutEffect(() => {
		const container = featuresRef.current
		const path = pathRef.current
		recalculate()
		if (!container || !path) return

		// 1) dot 위치 계산 (1, 3, 6번째 박스)
		const contRect = container.getBoundingClientRect()
		const GAP = 30
		// DOMRect 가져오기
		const firstRect = boxRefs.current[0].getBoundingClientRect()
		const thirdRect = boxRefs.current[2].getBoundingClientRect()
		const fourthRect = boxRefs.current[3].getBoundingClientRect()
		const lastRect = boxRefs.current[5].getBoundingClientRect()

		// X 위치 (각 박스 왼쪽에서 GAP만큼 왼쪽으로)
		const left1 = firstRect.left - contRect.left - GAP
		const left2 = thirdRect.left - contRect.left - GAP
		const left3 = lastRect.left - contRect.left - GAP

		// Y 위치: 첫 번째 · 세 번째(인덱스 2) · 마지막 박스의 수직 중앙
		const top1 = firstRect.top + firstRect.height / 2 - contRect.top
		const midRect = boxRefs.current[2].getBoundingClientRect()
		const top2 = Math.round(midRect.top + midRect.height / 2 - contRect.top)
		const top3 = lastRect.top + lastRect.height / 2 - contRect.top

		const positions = [
			{ left: left1, top: top1 },
			{ left: left2, top: top2 },
			{ left: left3, top: top3 },
		]
		setDotPositions(positions)

		const [p0, p1, p2] = positions
		const d01 = Math.hypot(p1.left - p0.left, p1.top - p0.top)
		const d12 = Math.hypot(p2.left - p1.left, p2.top - p1.top)
		const total = d01 + d12
		const thresholds = [0, d01 / total, 1]

		// 2) SVG path d 설정
		const points = positions.map((p) => ({
			x: p.left,
			y: p.top,
		}))
		const d = points.map((pt, i) => `${i === 0 ? 'M' : 'L'}${pt.x},${pt.y}`).join(' ')
		path.setAttribute('d', d)

		// 3) dash 설정
		const length = path.getTotalLength()
		setPathLength(length)
		path.style.strokeDasharray = length
		path.style.strokeDashoffset = length

		// 4) scroll 이벤트로 중앙 기준 애니메이션
		const handleScroll = () => {
			const rect = container.getBoundingClientRect()

			const anchorY = window.innerHeight * 0.5
			const progress = Math.min(Math.max((anchorY - rect.top) / rect.height, 0), 1)
			path.style.strokeDashoffset = length * (1 - progress)
			setShowDots(thresholds.map((t) => progress >= t))
		}

		const ro = new ResizeObserver(recalculate)
		ro.observe(container)
		window.addEventListener('resize', recalculate)
		// (기존) scroll 이벤트 등록도 그대로 두세요
		window.addEventListener('scroll', handleScroll)
		handleScroll() // 첫 렌더 시에도 한 번 실행
		return () => {
			window.removeEventListener('scroll', handleScroll)
			window.removeEventListener('resize', recalculate)
			ro.disconnect()
		}
	}, [])

	// 열려 있는 FAQ 인덱스 (현재는 아무 것도 안 열려 있음)

	const [openIdx, setOpenIdx] = useState(null)
	const toggle = (i) => {
		// 같은 걸 클릭하면 닫히도록 돼 있던 로직
		setOpenIdx((prev) => (prev === i ? null : i))
	}

	/*
	// 만약 하나는 무조건 열리게 하고 싶다면
	// 1) 첫 번째 질문이 디폴트로 열려 있게 0으로 초기화
	const [openIdx, setOpenIdx] = useState(0)
	// 2) 같은 질문 클릭해도 절대 닫히지 않고,
	// 다른 질문을 클릭하면 해당 인덱스만 열리도록
	const toggle = (i) => {
		if (openIdx !== i) {
			setOpenIdx(i)
		}
	}
*/

	return (
		<div>
			<MainHeader />
			<div className={styles.CaddyAcademy}>
				<section className={`${styles.hero} ${styles.fullSection_hero}`}>
					<h1 className={styles.heroTitle}>
						<span>
							필드의 핵심 전략가, 정규투어 투어캐디 스포이음이 당신의 전문성을
							완성합니다.
						</span>
					</h1>
					<p className={styles.heroSubtitle}>
						국내 유일의 KPGA/KLPGA 투어 전문 아카데미 당신의 전문성을 '투어 레벨'로
						격상시킬 국내 유일의 시스템. 스포이음이 유일한 해답입니다.
					</p>
					<div className={styles['hero-buttons']}>
						<a
							href="https://docs.google.com/forms/d/e/1FAIpQLSdJQ4UM4vqHEX21iC_4YcZrF6UHgO78LdDoMzZgFR37fuhmcw/viewform"
							target="_blank"
							rel="noopener noreferrer"
							className={`${styles.btn} ${styles.primary}`}>
							수강 신청하기
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								fill="currentColor"
								className={styles.btnIcon}>
								<path
									fillRule="evenodd"
									d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
									clipRule="evenodd"
								/>
							</svg>
						</a>
						<a
							href="https://www.notion.so/2a7250ea0d48804aa435fa101c840baf?source=copy_link"
							target="_blank"
							rel="noopener noreferrer"
							className={`${styles.btn} ${styles.secondary}`}>
							모집 요강 확인하기
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								fill="currentColor"
								className={styles.btnIcon}>
								<path
									fillRule="evenodd"
									d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
									clipRule="evenodd"
								/>
							</svg>
						</a>
					</div>
					<div className={styles.heroImage}>
						<img src="/images/caddymoney.png" alt="Caddy Money" />
					</div>
				</section>

				<section className={`${styles.content} ${styles.fullSection_content}`}>
					<div
						style={{
							position: 'absolute',
							top: 0,
							left: 0,
							width: '100%',
							height: '100%',
							backgroundImage: "url('/images/noise.png')",
							backgroundRepeat: 'repeat',
							backgroundSize: 'cover',
							opacity: 0.2,
							zIndex: 0,
						}}
					/>
					<div ref={featuresRef} style={{ position: 'relative', zIndex: 1 }}>
						<h2 className={styles.section2Heading} style={{ lineHeight: '1.4' }}>
							<span>
								당신의 전문성을 '투어 레벨'로 격상시킬 <br />
								국내 유일의 커리큘럼
							</span>
						</h2>
					</div>
					<div className={styles.featuresWrapper} ref={featuresRef}>
						<div className={styles.features}>
							{boxData.map((box, idx) => (
								<div
									key={idx}
									className={styles.featureBox}
									ref={(el) => (boxRefs.current[idx] = el)}>
									<MyIcon />
									<div className={styles.textBlock}>
										<span className={styles.boxTitle}>{box.title}</span>
										<span className={styles.boxSubtitle}>{box.subtitle}</span>
									</div>
								</div>
							))}

							{/* 3개의 dot */}
						</div>{' '}
						{/* /.features */}
						{/* dots + SVG (wrapper 기준으로 절대배치) */}
						{dotPositions.map(
							(pos, i) =>
								showDots[i] && (
									<div
										key={i}
										className={styles.dot}
										style={{ left: pos.left, top: pos.top }}
									/>
								),
						)}
						<svg className={styles.connectorSvg}>
							<path
								ref={pathRef}
								stroke="#085E4B69"
								strokeWidth={1}
								fill="none"
								transform="translate(6,0)"
							/>
						</svg>
					</div>{' '}
					{/* /.featuresWrapper */}
				</section>

				<section className={`${styles.content} ${styles.fullSection_content}`}>
					{/* noise overlay */}
					<div
						style={{
							position: 'absolute',
							top: 0,
							left: 0,
							width: '100%',
							height: '100%',
							backgroundImage: "url('/images/noise.png')",
							backgroundRepeat: 'repeat',
							backgroundSize: 'cover',
							opacity: 0.2,
							zIndex: 0,
						}}
					/>
					<div style={{ position: 'relative', zIndex: 1 }}>
						<img
							src="/images/location.png"
							alt="위치 이미지"
							className={styles.locationImage}
						/>
						<h2 className={styles.section2Heading} style={{ lineHeight: '1.4' }}>
							<span>
								스포이음 '투어캐디 아카데미'는 교육으로 끝나지 않습니다. 당신의
								'투어 캐디' 커리어를 완성합니다.
							</span>
						</h2>
						<div className={styles.careerPathContainer}>
							{/* Step 1: 교육 */}
							<div className={styles.careerStep}>
								<div className={styles.careerStepHeader}>
									<span className={styles.stepNumber}>1</span>
									<span className={styles.stepCategory}>[교육]</span>
								</div>
								<div className={styles.careerStepContent}>
									<h3 className={styles.careerStepTitle}>
										압도적인 '투어 캐디' 전문 심화 과정 수료
									</h3>
									<p className={styles.careerStepDescription}>
										골프 전공자 및 경력 캐디를 위한 최적화된 심화 커리큘럼. 실전
										라운드, 코스 매니지먼트, 멘탈 전략 등 투어 현장에서 즉시
										활용 가능한 핵심 역량을 완벽하게 습득합니다. 당신의 경험을
										투어 레벨의 전문성으로 격상시킵니다.
									</p>
								</div>
								<div className={styles.careerStepArrow}>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										className={styles.arrowIcon}>
										<path d="M5 12h14M12 5l7 7-7 7" />
									</svg>
								</div>
							</div>

							{/* Step 2: 플랫폼 */}
							<div className={styles.careerStep}>
								<div className={styles.careerStepHeader}>
									<span className={styles.stepNumber}>2</span>
									<span className={styles.stepCategory}>[플랫폼]</span>
								</div>
								<div className={styles.careerStepContent}>
									<h3 className={styles.careerStepTitle}>스포이음 플랫폼 등록</h3>
									<p className={styles.careerStepDescription}>
										아카데미 수료와 동시에 스포이음이 운영하는 국내 최대 규모의
										프로골프 투어 매칭 플랫폼 '스포이음'에 등록됩니다. 이는 다른
										어디에서도 경험할 수 없는, 투어캐디 커리어의 시작점입니다.
									</p>
								</div>
								<div className={styles.careerStepArrow}>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										className={styles.arrowIcon}>
										<path d="M5 12h14M12 5l7 7-7 7" />
									</svg>
								</div>
							</div>

							{/* Step 3: 매칭 */}
							<div className={styles.careerStep}>
								<div className={styles.careerStepHeader}>
									<span className={styles.stepNumber}>3</span>
									<span className={styles.stepCategory}>[매칭]</span>
								</div>
								<div className={styles.careerStepContent}>
									<h3 className={styles.careerStepTitle}>
										KPGA/KLPGA 투어선수 매칭
									</h3>
									<p className={styles.careerStepDescription}>
										플랫폼 등록 후, 검증된 투어 선수 및 국내 주요 대회에
										최우선으로 매칭됩니다. 단순한 경험이 아닌, 실제 정규투어
										현장에 즉각 투입되어 당신의 역량을 발휘할 수 있는 기회를
										제공합니다.
									</p>
								</div>
								<div className={styles.careerStepArrow}>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										className={styles.arrowIcon}>
										<path d="M5 12h14M12 5l7 7-7 7" />
									</svg>
								</div>
							</div>

							{/* Step 4: 성장 */}
							<div className={styles.careerStep}>
								<div className={styles.careerStepHeader}>
									<span className={styles.stepNumber}>4</span>
									<span className={styles.stepCategory}>[성장]</span>
								</div>
								<div className={styles.careerStepContent}>
									<h3 className={styles.careerStepTitle}>
										최상위 선수 전담 '해외 투어' 진출 기회
									</h3>
									<p className={styles.careerStepDescription}>
										국내 투어에서의 성공적인 경험을 바탕으로, 스포이음은
										정규투어 선수의 전담 캐디로 성장하고 해외 주요 투어까지
										진출할 수 있도록 적극적인 지원과 네트워크를 제공합니다.
										커리어는 한계 없이 확장될 것입니다.
									</p>
								</div>
							</div>
						</div>
					</div>
				</section>
				<section className={`${styles.content} ${styles.fullSection_content}`}>
					{/* noise overlay */}
					<div
						style={{
							position: 'absolute',
							top: 0,
							left: 0,
							width: '100%',
							height: '100%',
							backgroundImage: "url('/images/noise.png')",
							backgroundRepeat: 'repeat',
							backgroundSize: 'cover',
							opacity: 0.2,
							zIndex: 0,
						}}
					/>
					<div style={{ position: 'relative', zIndex: 1 }}>
						<img
							src="/images/chatbubble.png"
							alt="Chat Bubble"
							className={styles.chatBubble}
						/>
						<h2 className={styles.section2Heading}>
							<span>꿈을 현실로 만든 수강생들의</span>
							<span>솔직한 투어캐디 아카데미 후기를 확인해보세요!</span>
						</h2>
						<div className={styles.reviewBoxes}>
							{/* 첫 번째 박스 */}
							<div className={styles.reviewBox}>
								<div className={styles.reviewTextGroup}>
									<h3 className={styles.reviewTitle}>
										안정적인 캐디 생활이 가능해졌어요
									</h3>
									<hr className={styles.reviewDivider} />
									<p className={styles.reviewContent}>
										늘 불안정했던 캐디 일자리 때문에 고민이 많았습니다. 하지만
										이 플랫폼에서 연봉제 공고를 보고는 눈이 번쩍 뜨였죠. 제
										경력과 노하우를 바탕으로 제안을 보냈고, 정말 좋은 조건의
										프로님과 장기 계약을 맺을 수 있었습니다. 이제는 매 경기
										불안해하지 않고 오직 프로님의 경기력 향상에만 집중할 수 있게
										되었어요. 안정적인 수입과 함께 전문성을 계속 발전시킬 수
										있어 정말 만족스럽습니다. 저처럼 안정적인 커리어를 원하는
										캐디분들께 강력 추천합니다!
									</p>
									<hr className={styles.reviewDivider} />
									<div className={styles.reviewFooter}>
										<span className={styles.reviewAuthor}>최**</span>
										<span className={styles.reviewBadge}>1기 수강생</span>
									</div>
								</div>
							</div>

							{/* 두 번째 박스 */}
							<div className={styles.reviewBox}>
								<div className={styles.reviewTextGroup}>
									<h3 className={styles.reviewTitle}>캐디 커리어의 전환점</h3>
									<hr className={styles.reviewDivider} />
									<p className={styles.reviewContent}>
										캐디로서 더 많은 투어 경험을 쌓고 싶었지만, 기회를 잡기가
										쉽지 않았습니다. 개인적으로 프로에게 연락하는 것도 한계가
										있었고요. 이 플랫폼에 제 프로필을 올리고 나서는 정말 다양한
										제안을 받게 됐습니다. 특히 제가 선호하는 고수익 단기 대회
										공고를 빠르게 확인할 수 있어서 좋았어요. 얼마 전에는 해외
										투어 경력이 있는 프로님과 함께 일하게 되어 값진 경험을
										쌓았습니다. 캐디라면 꼭 이용해봐야 할 필수 서비스라고
										생각해요.
									</p>
									<hr className={styles.reviewDivider} />
									<div className={styles.reviewFooter}>
										<span className={styles.reviewAuthor}>김**</span>
										<span className={styles.reviewBadge}>1기 수강생</span>
									</div>
								</div>
							</div>

							{/* 세 번째 박스 */}
							<div className={styles.reviewBox}>
								<div className={styles.reviewTextGroup}>
									<h3 className={styles.reviewTitle}>
										안정적인 캐디 생활이 가능해졌어요
									</h3>
									<hr className={styles.reviewDivider} />
									<p className={styles.reviewContent}>
										늘 불안정했던 캐디 일자리 때문에 고민이 많았습니다. 하지만
										이 플랫폼에서 연봉제 공고를 보고는 눈이 번쩍 뜨였죠. 제
										경력과 노하우를 바탕으로 제안을 보냈고, 정말 좋은 조건의
										프로님과 장기 계약을 맺을 수 있었습니다. 이제는 매 경기
										불안해하지 않고 오직 프로님의 경기력 향상에만 집중할 수 있게
										되었어요. 안정적인 수입과 함께 전문성을 계속 발전시킬 수
										있어 정말 만족스럽습니다. 저처럼 안정적인 커리어를 원하는
										캐디분들께 강력 추천합니다!
									</p>
									<hr className={styles.reviewDivider} />
									<div className={styles.reviewFooter}>
										<span className={styles.reviewAuthor}>최**</span>
										<span className={styles.reviewBadge}>1기 수강생</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<section className={`${styles.content} ${styles.fullSection_faq}`}>
					<div className={styles.faq}>
						{faqs.map((f, i) => (
							<div key={i} className={styles.faqItem}>
								<button className={styles.faqQuestion} onClick={() => toggle(i)}>
									{f.question}
									<span className={styles.toggleIcon}>
										{openIdx === i ? (
											<svg
												xmlns="http://www.w3.org/2000/svg"
												viewBox="0 0 24 24"
												width="24"
												height="24"
												fill="currentColor">
												<path
													fillRule="evenodd"
													clipRule="evenodd"
													d="M11.47 7.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z"
												/>
											</svg>
										) : (
											<svg
												xmlns="http://www.w3.org/2000/svg"
												viewBox="0 0 24 24"
												width="24"
												height="24"
												fill="currentColor">
												<path
													fillRule="evenodd"
													clipRule="evenodd"
													d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z"
												/>
											</svg>
										)}
									</span>
								</button>
								{openIdx === i && (
									<p className={styles.faqAnswer}>
										{f.answer.split('\n').map((line, idx) => (
											<span key={idx}>
												{line}
												<br />
											</span>
										))}
									</p>
								)}
							</div>
						))}
					</div>
				</section>
				<section
					className={styles.content}
					style={{
						position: 'relative',
						width: '100vw',
						marginLeft: 'calc(50% - 50vw)',
						marginRight: 'calc(50% - 50vw)',
						overflow: 'hidden',
						minHeight: '60vh', // 높이는 필요에 따라 조정
						backgroundImage: "url('/images/zoomputting.png')",
						backgroundSize: 'cover',
						backgroundPosition: 'center',
						backgroundRepeat: 'no-repeat',
					}}>
					<div style={{ position: 'relative', zIndex: 1, padding: '4rem 1rem' }}>
						<div className={styles.blockIconWrapper}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								fill="currentColor"
								className={styles.blockIcon}>
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M11.47 13.28a.75.75 0 0 0 1.06 0l7.5-7.5a.75.75 0 0 0-1.06-1.06L12 11.69 5.03 4.72a.75.75 0 0 0-1.06 1.06l7.5 7.5Z"
								/>
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M11.47 19.28a.75.75 0 0 0 1.06 0l7.5-7.5a.75.75 0 1 0-1.06-1.06L12 17.69l-6.97-6.97a.75.75 0 0 0-1.06 1.06l7.5 7.5Z"
								/>
							</svg>
						</div>
						<p className={styles.zoomTitleMain}>
							성공적인 캐디의 길,
							<br />
							지금 바로 시작하세요!
						</p>
						<p className={styles.zoomSubtitle}>
							KPGA 및 KLPGA 투어전문 캐디를 양성하는 국내 유일의 아카데미입니다.
							<br />
							실전 경험이 없어도 OK 스포이음과 함께 전문 투어 캐디로 거듭나세요.
						</p>
						<div className={styles.zoomButtons}>
							<a
								href="https://docs.google.com/forms/d/e/1FAIpQLSdJQ4UM4vqHEX21iC_4YcZrF6UHgO78LdDoMzZgFR37fuhmcw/viewform"
								target="_blank"
								rel="noopener noreferrer"
								className={`${styles.zoomPrimary}`}>
								수강 신청하기
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 24 24"
									fill="currentColor"
									className={styles.btnIcon}>
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 
           7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 
           5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
									/>
								</svg>
							</a>
							<a
								href="https://www.notion.so/2a7250ea0d48804aa435fa101c840baf?source=copy_link"
								target="_blank"
								rel="noopener noreferrer"
								className={`${styles.zoomSecondary}`}>
								모집 요강 확인하기
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 24 24"
									fill="currentColor"
									className={styles.btnIcon}>
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 
           7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 
           5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
									/>
								</svg>
							</a>
						</div>
					</div>
				</section>
			</div>
			<MainFooter />
		</div>
	)
}

export default CaddyAcademy
